import * as types from "./../action-types";
import axios from "axios";

const device = (commit, action, data) =>
  commit(`db/device/${action}`, data, { root: true });

async function fetchEvent({ commit }, { eventId, user_id }) {
  try {
    const response = await axios.get(`/v2/events/${eventId}`, {
      params: { user_id },
    });
    return response;
  } catch (error) {
    throw error.response;
  }
}

async function fetchRecordingData({ commit }, { eventId, doorbotId, ownerId }) {
  try {
    const response = await axios.get(
      `/v2/events/${eventId}/recording?device_id=${doorbotId}&user_id=${ownerId}`
    );
    return response;
  } catch (error) {
    throw error;
  }
}

async function fetchAuthorizations(
  { commit },
  { eventId, doorbotId, ownerId }
) {
  try {
    const response = await axios.get(
      `/v2/events/${eventId}/authorizations?device_id=${doorbotId}&user_id=${ownerId}`
    );
    return response;
  } catch (error) {
    throw error;
  }
}

async function fetchDeviceData({ commit }, { eventId, doorbotId }) {
  try {
    const response = await axios.get(
      `/v2/events/${eventId}/device?device_id=${doorbotId}`
    );
    console.log("types.FETCH_DEVICE.SUCCESS", types.FETCH_DEVICE.SUCCESS);
    console.log("Device loaded:", response);
    device(commit, types.FETCH_DEVICE.SUCCESS, { device: response.data });

    return response.data;
  } catch (error) {
    throw error;
  }
}

async function getBitRateData(
  { commit },
  { start_timestamp, end_timestamp, doorbotId }
) {
  try {
    const response = await axios.get(
      `/v2/devices/${doorbotId}/visualization.json?start_timestamp=${start_timestamp}&end_timestamp=${end_timestamp}`
    );
    return response;
  } catch (error) {
    throw error;
  }
}

async function getPnsLogsData({ commit }, { eventId, userId }) {
  try {
    const response = await axios.get(
      `/dings/${eventId}/get_pns.json?user_id=${userId}`
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export default {
  fetchEvent,
  fetchRecordingData,
  fetchAuthorizations,
  fetchDeviceData,
  getBitRateData,
  getPnsLogsData,
};
